// ONLY MODIFY THIS FILE BY RUNNING THE FOLLOWING COMMAND:
// php artisan react:enum

export const CustomerPaymentTerms = {
  DueOnReceipt: {
    Name: 'Due On Receipt',
    Value: 'due_on_receipt',
    Label: 'Due On Receipt',
  },
  Net15: {
    Name: 'Net 15',
    Value: 'net_15',
    Label: 'Net 15',
  },
  Net30: {
    Name: 'Net 30',
    Value: 'net_30',
    Label: 'Net 30',
  },
  Net60: {
    Name: 'Net 60',
    Value: 'net_60',
    Label: 'Net 60',
  },
  Custom: {
    Name: 'Custom',
    Value: 'custom',
    Label: 'Custom',
  },
} as const

export type CustomerPaymentTermsValue =
  (typeof CustomerPaymentTerms)[keyof typeof CustomerPaymentTerms]['Value']
